/* 🤖 this file was generated by svg-to-ts*/
export const icoSend: {
  name: 'send';
  data: string;
} = {
  name: 'send',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.02 9.196l.032.121a1 1 0 00.685.648L11.2 12l-7.463 2.035a1 1 0 00-.718.769l-1 5a1 1 0 001.387 1.11l18-8c.792-.352.792-1.476 0-1.828l-18-8a1 1 0 00-1.387 1.11l1 5z" fill="#909090"/></svg>`
};
